module.exports = __webpack_public_path__ + "img/kids-m-2.8e3c30c6.jpg";